import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { defineMessages, FormattedMessage } from 'react-intl';
import { Modal } from 'ui-components/components/modal';
import { ModalHeader } from 'ui-components/components/modal/modal-header';
import { ModalBody } from 'ui-components/components/modal/modal-body';
import { noop } from 'ui-components/default-props/noop';
import style from './style.module.less';

const messages = defineMessages({
  reviewAdjustmentsModalTitle: {
    description: 'review adjustments modal title',
    defaultMessage: 'Review Adjustments',
    id: 'U7/DgH',
  },
  reviewAdjustmentsMessage: {
    description: 'review adjustments modal message',
    defaultMessage: 'The selling channel has indicated that the following adjustments were made to the order.',
    id: 'iuTZL6',
  },
  item: {
    description: 'review adjustments modal item column',
    defaultMessage: 'Item',
    id: 'q6wqZA',
  },
  previousQuantity: {
    description: 'review adjustments modal previous quantity column',
    defaultMessage: 'Previous Qty',
    id: '8Eta0X',
  },
  newQuantity: {
    description: 'review adjustments modal new quantity column',
    defaultMessage: 'New Qty',
    id: '5KTYcx',
  },
});

const ReviewAdjustmentsModal = ({ onCloseModal = noop, adjustments }) => {
  return (
    <Modal>
      <ModalHeader closeModal={onCloseModal}>
        <FormattedMessage {...messages.reviewAdjustmentsModalTitle} />
      </ModalHeader>
      <ModalBody className={style['modal-body']}>
        <FormattedMessage {...messages.reviewAdjustmentsMessage} />
        <div className={style['items-grid']}>
          <div className={style['column-header']}>
            <FormattedMessage {...messages.item} />
          </div>
          <div className={classnames(style['column-header'], style['quantity-column'])}>
            <FormattedMessage {...messages.previousQuantity} />
          </div>
          <div className={classnames(style['column-header'], style['quantity-column'])}>
            <FormattedMessage {...messages.newQuantity} />
          </div>
          {adjustments.map((item) => (
            <React.Fragment key={item.salesOrderItemId}>
              <div className={style['column-data']}>{item.name}</div>
              <div className={classnames(style['column-data'], style['quantity-column'])}>{item.originalQuantity}</div>
              <div className={classnames(style['column-data'], style['quantity-column'])}>{item.quantity}</div>
            </React.Fragment>
          ))}
        </div>
      </ModalBody>
    </Modal>
  );
};

ReviewAdjustmentsModal.propTypes = {
  adjustments: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      originalQuantity: PropTypes.number.isRequired,
      quantity: PropTypes.number.isRequired,
    }),
  ).isRequired,
  onCloseModal: PropTypes.func,
};

export default ReviewAdjustmentsModal;
